<template>
  <div>
    <data-table
      ref="table"
      :fetch-from="fetchForm"
      :fields="fields"
    >
      <template
        slot="actions"
        slot-scope="slotData"
      >
        <v-btn
          x-small
          color="primary"
          @click="showDetails(slotData.rowData)"
        >Edit</v-btn>
      </template>
    </data-table>
    <v-btn
      color="primary"
      class="mr-4"
      small
      @click="showAddDialog()"
    >
      Add new
    </v-btn>
    <empty-space />
    <modal-form
      title="Document"
      :show="dialog"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-row>
          <v-col cols="4">
            <project
              :readonly="isReadOnly()"
              label='Project'
              :value="getValue(item, 'project_id')"
              @input="setValue(item, 'project_id', $event)"
            ></project>
          </v-col>
          <v-col cols="4">
            <designer-company
              :readonly="isReadOnly()"
              label="Designer company"
              :value="getValue(item, 'designer_company_id')"
              @input="setValue(item, 'designer_company_id', $event)"
            ></designer-company>
          </v-col>
          <v-col cols="4">
            <design-type
              :readonly="isReadOnly()"
              label="Design type"
              :value="getValue(item, 'design_type_id')"
              @input="setValue(item, 'design_type_id', $event)"
            ></design-type>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <file-upload
              :readonly="isReadOnly()"
              label="Document"
              module="design"
              section="documents"
              :site_id="site.site_id"
              :item_id="itemId"
              @input="setValue(item, 'files', $event)"
            ></file-upload>
          </v-col>
        </v-row>
      </v-form>
    </modal-form>
  </div>
</template>

<script>
  import DataTable from '@/components/DataTable'
  import ModalForm from '@/components/ModalForm'
  import Actions from '@/components/Actions'
  import DesignerCompany from '@/components/codelist/DesignerCompany'
  import Project from '@/components/codelist/Project'
  import DesignType from '@/components/codelist/DesignType'
  import FileUpload from '@/components/FileUpload'
  import ReactivitMixin from '@/mixins/Reactivity'
  import ValidationMixin from '@/mixins/Validation'
  import SiteDesignDocumentService from '@/services/site-design-document'
  import PermissionsMixin from '@/mixins/Permissions'

  export default {
    name: 'Documents',
    mixins: [
      ReactivitMixin,
      ValidationMixin,
      PermissionsMixin,
    ],
    components: { FileUpload, DesignType, Project, DesignerCompany, Actions, ModalForm, DataTable },
    props: {
      site: {
        default: undefined,
      },
    },
    computed: {
      itemId () {
        if (this.item.id) {
          return this.item.id
        }
        return undefined
      },
    },
    data: function () {
      return {
        dialog: false,
        item: {},
        fields: [
          {
            name: 'project_name',
            title: 'Project',
          },
          {
            name: 'designer_company_name',
            title: 'Designer company',
          },
          {
            name: 'design_type_name',
            title: 'Design type',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
        section: 'documents',
      }
    },
    methods: {
      fetchForm (urls, options) {
        const dcs = new SiteDesignDocumentService(this.site.id)
        return dcs.list(options.params)
      },
      showAddDialog () {
        this.item = {}
        this.dialog = true
      },
      showDetails (item) {
        this.item = item
        this.dialog = true
      },
      doSave () {
        this.validate()
        if (this.valid) {
          if (this.item.id) {
            const dds = new SiteDesignDocumentService(this.site.id)
            dds.put(this.item.id, this.item).then(() => {
              this.$refs.table.refresh()
              this.dialog = false
            })
          } else {
            const dds = new SiteDesignDocumentService(this.site.id)
            dds.post(this.item).then(() => {
              this.$refs.table.refresh()
              this.dialog = false
            })
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
